// Abonelik planları ve limitleri. Yeni plan veya fiyatlandırma kararı yalnızca burayı değiştirir;
// limitler sunucuda denetlenir, arayüz yalnızca gösterir.
export const PLANS = {
  deneme: { label: 'Deneme', maxStudents: 10, maxLessons: 10, maxPdfMb: 15, retentionDays: 14 },
  standart: { label: 'Standart', maxStudents: 30, maxLessons: 100, maxPdfMb: 30, retentionDays: 90 },
} as const;

export type PlanId = keyof typeof PLANS;
export const PLAN_IDS = Object.keys(PLANS) as PlanId[];
export const DEFAULT_PLAN: PlanId = 'deneme';

export const ACCOUNT_STATUSES = ['trialing', 'active', 'past_due', 'canceled', 'suspended'] as const;
export type AccountStatus = (typeof ACCOUNT_STATUSES)[number];

export const STATUS_LABELS: Record<AccountStatus, string> = {
  trialing: 'Deneme sürecinde',
  active: 'Aktif',
  past_due: 'Ödeme gecikti',
  canceled: 'İptal edildi',
  suspended: 'Askıya alındı',
};

export function planOf(id: string): (typeof PLANS)[PlanId] {
  return PLANS[id as PlanId] ?? PLANS[DEFAULT_PLAN];
}

/** Hesap ders açıp yürütebilir mi? Ödeme entegrasyonu geldiğinde yalnızca status ve periodEnd güncellenir. */
export function isEntitled(account: { status: string; periodEndMs: number | null }, now = Date.now()): boolean {
  if (account.status !== 'active' && account.status !== 'trialing') return false;
  return account.periodEndMs === null || account.periodEndMs > now;
}

/** Hukuki metinler değişince artar; kullanıcının hangi sürümü kabul ettiği kayıtlıdır. */
export const TERMS_VERSION = '2026-11-03.3';
export const TERMS_EFFECTIVE_LABEL = '3 Kasım 2026';
export const LEGAL_CONTACT = 'info@supernova-academy.org';

/** Fiyat teklifi isteyen öğretmenin formu; ödeme gelene kadar yükseltmeler bununla yapılır. */
export interface PlanRequest {
  id: string;
  plan: PlanId;
  phone: string | null;
  institution: string | null;
  studentCount: number | null;
  message: string | null;
  createdAt: number;
}

export interface AdminPlanRequest extends PlanRequest {
  name: string;
  email: string;
  currentPlan: PlanId;
}

export interface MeResponse {
  /** Yalnızca yöneticide: bekleyen paket talebi sayısı. */
  adminOpenRequests?: number;
  user: {
    id: string;
    email: string;
    name: string;
    isAdmin: boolean;
    mustChangePassword: boolean;
    emailVerified: boolean;
    emailVerifiedMs: number | null;
    createdAt: number;
  } | null;
  account?: {
    id: string;
    name: string;
    plan: PlanId;
    status: AccountStatus;
    periodEndMs: number | null;
    entitled: boolean;
    lessonCount: number;
  };
}

export interface LessonParticipant {
  name: string;
  role: 'teacher' | 'student';
  /** Öğretmen için derste kaldığı süre; öğrenci için öğretmenle birlikte geçirdiği süre. */
  ms: number;
  lastSeenMs: number;
}

export interface LessonSummary {
  id: string;
  title: string;
  pdfName: string;
  pageCount: number;
  teacherKey: string;
  createdAt: number;
  durationMs: number;
  studentCount: number;
  annotationCount: number;
  lastActivityMs: number;
  participants: LessonParticipant[];
}

export interface StudentSummary {
  name: string;
  lessonCount: number;
  totalMs: number;
  lastSeenMs: number;
  lessons: { id: string; title: string; ms: number; at: number }[];
}

export interface TeacherReport {
  lessons: LessonSummary[];
  students: StudentSummary[];
  totals: { lessonCount: number; studentCount: number; teachingMs: number };
}

export interface PlanChange {
  from: string;
  to: string;
  at: number;
}

export interface AdminTeacher {
  userId: string;
  accountId: string;
  email: string;
  name: string;
  isAdmin: boolean;
  active: boolean;
  emailVerified: boolean;
  plan: PlanId;
  status: AccountStatus;
  periodEndMs: number | null;
  lessonCount: number;
  lastLoginMs: number | null;
  createdAt: number;
}
